import { Paragraf } from './IntroParagraph.styled';

const IntroParagraph = () => {
  return (
    <Paragraf>
      Whether you're envisioning a stunning website, a captivating marketing
      campaign, or a cutting-edge digital solution, we're here to bring your
      ideas to life.
    </Paragraf>
  );
};

export default IntroParagraph;
